import { render, staticRenderFns } from "./PairedElementView.vue?vue&type=template&id=4498d077"
import script from "./PairedElementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairedElementView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports